import ApiClient from './ApiClient';
import store from "@/store";
import {grantAccessToApplication, logInToApplication} from "@/services/ApplicationService";
import {isGranted} from "@dealer-group/dealerui";

export function resetPassword(email) {
    return ApiClient.post(
        '/security/reset-password/send-message',
        {email}
    );
}

export function checkResetToken(token) {
    return ApiClient.post(
        '/security/reset-password/check-token',
        {token}
    );
}

export function setNewPassword(token, password) {
    return ApiClient.post(
        '/security/reset-password/set-new-password/' + token,
        {password}
    )
}

export function getNewToken(token) {
    let request = {method: 'GET', url: '/security/auth/new-token'};
    if (token) {
        request.headers = {'Authorization': "Bearer " + token};
    }
    return ApiClient(request);
}

export function grantAccessToContextApp(router, next) {
    let vue = router.app;
    if (store.getters['Auth/hasAccessToContextApp']) {
        return logInToApplication(
            store.state.context.app,
            store.state.context.continueUrl,
            store.state.context.method
        );
    }

    let appName = store.state.context.app.name;
    let email = store.getters['Auth/user'].email;

    vue.$swal({
        icon: 'error',
        title: vue.$t('auth.no_access_to_application_title', {appName}),
        text: vue.$t('auth.no_access_to_application_text', {email, appName}),
        showConfirmButton: isGranted('$gd.service'),
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: vue.$t('auth.no_access_to_application_grant_access_button'),
        denyButtonText: vue.$t('auth.no_access_to_application_logout_button'),
        cancelButtonText: vue.$t('auth.no_access_to_application_no_button'),
        customClass: {
            confirmButton: 'btn btn-success btn-lg',
            denyButton: 'btn btn-primary btn-lg',
            cancelButton: 'btn btn-link btn-lg'
        }
    }).then((result) => {
        if (result.isDenied) {
            return store.dispatch('Auth/logout').then(() => router.push('Login'));
        }

        if (result.isConfirmed) {
            return grantAccessToApplication(store.state.context.app.uuid)
                .then(() => logInToApplication(
                    store.state.context.app,
                    store.state.context.continueUrl,
                    store.state.context.method
                ));
        }

        return store.dispatch('removeContextApplication').then(() => next())
    });
}

export default {
    login (email, password) {
        return ApiClient.post(
            'security/auth/login',
            {email, password, context: 'b112b953-11c8-4d4b-9adf-65e59deb03b5' }
        );
    },

    loginByCode(code) {
        return ApiClient.post(
            '/auth/oauth2/token',
            {
                grantType: 'code',
                code,
            }
        );
    },

    checkToken(token) {
        return ApiClient({
            method: 'GET',
            url: '/security/auth/check-token',
            headers: {'Authorization': "Bearer " + token}
        });
    }
}

